<micro-select-combo #sel
              placeholder="Notification Subscription"
              routerBase="notif/subscriptions"
              [mode]="mode"
              [(id)]="subscriptionId"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
